import React, { useState } from "react";
import ClaimType from "../../components/sections/claim-type";
import ClaimDetails from "../../components/sections/claim-details";
import Uploads from "./uploads";
import Steps from "../../components/elements/steps";

const CLAIM_STEPS = [
  { title: "Claim type" },
  { title: "Documents" },
  { title: "Review" },
];

// Maps the internal `tab` values (0, 1, 3 - tab 2 is unused) to a
// contiguous step index for the progress indicator.
const STEP_INDEX_BY_TAB: Record<number, number> = { 0: 0, 1: 1, 3: 2 };

export default function Request() {
  const [tab, setTab] = useState<number>(0);
  const [persist, setPersist] = useState<any>({});
  return (
    <div className="md:p-4 p-2">
      <div className="bg-white rounded-lg w-full min-h-[85vh] py-6">
        <div className="flex justify-center mb-8 px-4">
          <Steps items={CLAIM_STEPS} current={STEP_INDEX_BY_TAB[tab] ?? 0} />
        </div>
        {tab === 0 && (
          <ClaimType
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
        {tab === 1 && (
          <Uploads
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
        {tab === 3 && (
          <ClaimDetails
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
      </div>
    </div>
  );
}
